import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';

function QuickAdd() {
  const ref = useEsiPortal('esi-quick-add');
  return <div ref={ref} data-testid="quick-add" />;
}

export default QuickAdd;
